import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_chart_js = _resolveComponent("vue3-chart-js")!

  return (_openBlock(), _createBlock(_component_vue3_chart_js, _mergeProps({ ref: "chart" }, { ..._ctx.barChart }), null, 16))
}